import { FC, ReactNode } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { capitalizeFirstLetter } from '@bts-web/utils-formatting';

export interface BelowInputInfoTableProps {
  items: { title?: string | ReactNode; value?: string | ReactNode }[];
  variant?: 'primary' | 'warning';
}

export const BelowInputInfoTable: FC<BelowInputInfoTableProps> = ({
  items,
  variant = 'primary',
}) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <table
      className={css({
        width: '100%',
      })}
      data-testid="below-input-info-table"
    >
      <tbody
        className={css({
          display: 'flex',
          flexDirection: 'column',
          gap: 'small',
        })}
      >
        {items.map((item) => {
          const { title, value } = item;

          return (
            <tr
              key={`${title}-${value}`}
              className={css({
                display: 'flex',
                justifyContent: 'space-between',
              })}
              data-testid="below-input-info-table-row"
            >
              {title && (
                <>
                  {typeof title === 'string' ? (
                    <td
                      className={css({
                        color: 'neutrals.text_secondary',
                        fontSize: 'body.medium',
                        fontWeight: 'body.medium',
                        letterSpacing: 'body.medium',
                        lineHeight: 'body.medium',
                        textAlign: 'start',
                      })}
                    >
                      {capitalizeFirstLetter(title)}
                    </td>
                  ) : (
                    <td>{title}</td>
                  )}
                </>
              )}

              <td
                className={css({
                  fontSize: 'title.medium_medium',
                  fontWeight: 'body.medium_medium',
                  letterSpacing: 'body.medium',
                  lineHeight: 'title.large_medium',
                  textAlign: 'end',
                  ...(variant === 'primary'
                    ? {
                        color: 'neutrals.text_primary',
                      }
                    : {}),
                  ...(variant === 'warning'
                    ? {
                        color: 'warning.text_primary',
                      }
                    : {}),
                  ...(title === undefined
                    ? {
                        color: 'neutrals.text_secondary',
                      }
                    : {}),
                })}
              >
                {value}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
